import { render, staticRenderFns } from "./member-order.vue?vue&type=template&id=5d723da4"
import script from "./member-order.vue?vue&type=script&lang=ts"
export * from "./member-order.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports